import React from 'react'
import { NavLink } from 'react-router-dom'
import css from './header.module.css'
const DropLink = ({currentLink, page}) => {
    const {id, title, desc, link} = currentLink
if(page === undefined){
    return (
      <div className={css.drop_link}>
          <li>
              <NavLink to={link} className={css.single_link_style}>
                  <span>{id}</span>
                  <div>
                      <h5>{title}</h5>
                      <p>{desc}</p>
                  </div>
              </NavLink>
          </li>
      </div>
    )
}else{
    return (
        <div className={css.drop_link}>
            <li>
                <NavLink to={link} className={css.single_link_style}>
                    <div  style={{display: 'flex', alignItems: 'center'}} >
                        <h5>{desc}</h5>
                        <h5 style={{paddingLeft: '0.5rem'}}>{title}</h5>
                    </div>
                </NavLink>
            </li>
        </div>
      )
}
}

export default DropLink